import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';

export enum ENUM__t2i_adapter_type {
  COLOR = 'color',
  STYLE = 'style',
  CANNY = 'canny',
  SKETCH = 'sketch',
  DEPTH = 'depth',
  ZOE_DEPTH = 'zoedepth',
  SEGMENTATION = 'segmentation',
}

export namespace ENUM_UTILS__t2i_adapter_type {
  export function get_image_category_for(type: ENUM__t2i_adapter_type): ENUM__image_asset_category {
    let out_map = new Map<ENUM__t2i_adapter_type, ENUM__image_asset_category>([
      [ENUM__t2i_adapter_type.COLOR, ENUM__image_asset_category.COLOR_MAP],
      [ENUM__t2i_adapter_type.STYLE, ENUM__image_asset_category.IMAGE],
      [ENUM__t2i_adapter_type.CANNY, ENUM__image_asset_category.LINE__CANNY],
      [ENUM__t2i_adapter_type.SKETCH, ENUM__image_asset_category.LINE__SCRIBBLE],
      [ENUM__t2i_adapter_type.DEPTH, ENUM__image_asset_category.DEPTH],
      [ENUM__t2i_adapter_type.ZOE_DEPTH, ENUM__image_asset_category.DEPTH__ZOE],
      [ENUM__t2i_adapter_type.SEGMENTATION, ENUM__image_asset_category.SEGMENTATION],
    ]);

    let out = out_map.get_or_assert(type);

    return out;
  }
}
